//import * as _ from './utils';

/**
 * DOM manipulations helper
 */
export default class Dom {
    /**
     * Creates SVG icon linked to the sprite
     *
     * @param {string} name - name (id) of icon from sprite
     * @param {number} [width] - icon width
     * @param {number} [height] - icon height
     *
     * @returns {SVGElement}
     */
    public static svg(name: string, width = 14, height = 14): SVGElement {
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

        icon.classList.add('icon', 'icon--' + name);
        icon.setAttribute('width', width + 'px');
        icon.setAttribute('height', height + 'px');
        icon.innerHTML = `<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${name}"></use>`;

        return icon;
    }

    /**
     * Checks target if it is native input
     *
     * @param {*} target - HTML element or string
     *
     * @returns {boolean}
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static isNativeInput(target: any): target is HTMLInputElement | HTMLTextAreaElement {
        const nativeInputs = [
            'INPUT',
            'TEXTAREA',
        ];

        return target && target.tagName ? nativeInputs.includes(target.tagName) : false;
    }

    /**
     * Checks if we can set caret
     *
     * @param {HTMLElement} target - target to check
     *
     * @returns {boolean}
     */
    public static canSetCaret(target: HTMLElement): boolean {
        let result = true;

        if (Dom.isNativeInput(target)) {
            switch (target.type) {
                case 'file':
                case 'checkbox':
                case 'radio':
                case 'hidden':
                case 'submit':
                case 'button':
                case 'image':
                case 'reset':
                    result = false;
                    break;
            }
        } else {
            result = Dom.isContentEditable(target);
        }

        return result;
    }

    /**
     * Check if passed element is contenteditable
     *
     * @param {HTMLElement} element - html element to check
     *
     * @returns {boolean}
     */
    public static isContentEditable(element: HTMLElement): boolean {
        return element.contentEditable === 'true';
    }

    /**
     * Check if object is DOM node
     *
     * @param {*} node - object to check
     *
     * @returns {boolean}
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static isElement(node: any): node is Element {
        if (typeof(node) === 'number') {
            return false;
        }

        return node && node.nodeType && node.nodeType === Node.ELEMENT_NODE;
    }
}
